export default __webpack_public_path__ + "static/media/resume.c2990da3.pdf";